import { createContext } from 'react';

import type { AuthActions, LoginResponse } from './AuthProvider';

const AuthStateContext = createContext<LoginResponse>(null);
const AuthActionsContext = createContext<AuthActions | undefined>(undefined);

export { AuthStateContext, AuthActionsContext };
